import { ROOMS } from 'client/api';
import { clientAdmin } from 'client/request';

const getRooms = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(ROOMS, {});

    return res.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getRooms
};
